import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {ReactComponent as LogoutBtn} from "../../assets/newIcons/logoutIcon.svg";
import {clearPersistedData} from "../../store/configureStore";
import {deAuthenticate} from "../../store/reducers/authSlice";
import SidebarData from "./Sidebar";
import SubMenu from "./SideBarMenu";
import {PURGE_Brand} from "../../store/reducers/brandSlice";
import {TOGGLE_Brand} from "../../store/reducers/brandSlice";
import {ReactComponent as BrandIcon} from "../../assets/newIcons/brandLogo.svg";
import {ReactComponent as BrandLogoIcon} from "../../assets/newIcons/brandLogoIcon.svg";
import {ReactComponent as CryptoBrandIcon} from "../../assets/newIcons/cryptoBrandLogo.svg";
import {ReactComponent as CryptoBrandLogoIcon} from "../../assets/newIcons/cryptoBrandLogoIcon.svg";
import {Button, Dropdown} from "antd";
const MainSidebar = ({setMobileMenu}) => {
  const accountListRedux = useSelector((state) => state?.account?.accountList?.data);
  const [accountCount, setAccountCount] = useState(accountListRedux);
  useEffect(() => {
    setAccountCount(accountListRedux?.length);
  }, [accountListRedux]);
  const [activeTab, setActiveTab] = useState("");
  const [subMenuActiveTab, setSubMenuActiveTab] = useState(null);
  // const accountList = useSelector((state) => state.account.accountList.data);
  const location_path = useLocation();

  var pathnameSegments = location_path.pathname.split("/");
  var desiredPart = pathnameSegments[1];
  const {plans} = useSelector((state) => state?.account);

  useEffect(() => {
    const currentLocation = "/" + desiredPart;

    switch (currentLocation) {
      case "/":
        setActiveTab("Dashboard");
        break;

      case "/account-metrics":
        setActiveTab("Account Metrics");
        break;

      case "/funding-evaluation-payment":
        setActiveTab("Payments");
        break;

      // Trading Cup
      // case "/tradingCup-leaderboard":
      //   setActiveTab("Trading Cup");
      //   break;

      case "/evaluation":
        setActiveTab("Buy Funded Account");
        break;

      case `/funding-evaluation`:
        setActiveTab("Choose challenge");
        break;

      case "/trademate":
        setActiveTab("Market Analysis");
        break;
      case "/trademate/economic-calendar":
        setActiveTab("Market Analysis");
        break;
      case "/trademate/market-news":
        setActiveTab("Market Analysis");
        break;

      case "/affiliate":
        setActiveTab("Affiliate");
        break;
      case "/affiliate/get-a-link":
        setActiveTab("Affiliate");
        break;

      case "/request-payout":
        setActiveTab("Withdrawals");
        break;
      case "/request-payout/affiliate-payout":
        setActiveTab("Withdrawals");
        break;
      case "/payout-leaderboard":
        setActiveTab("Payout Leaderboard");
        break;
      case "/verification-kyc":
        setActiveTab("KYC");
        break;

      case "/myprofile":
        setActiveTab("Settings");
        break;

      case "/support-center":
        setActiveTab("Support");
        break;
      case "/verification-kyc":
        setActiveTab("KYC");
        break;
      case "/billing-details":
        setActiveTab("Billing Details");
        break;
      case "/download":
        setActiveTab("Download");
        break;

      case "/buy-funded":
        setActiveTab("BuyFundedAccount");
        break;
      case "/certificates":
        setActiveTab("Certificates");
        break;
      case "/Contract-list":
        setActiveTab("Contract");
        break;

      default:
      // Handle default case here if needed
    }
  }, [window.location.pathname]);

  useEffect(() => {
    const location = window.location.pathname;
    switch (location) {
      case "/account-metrics/program-objectives":
        setSubMenuActiveTab("Program Objectives");
        break;
      case "/account-metrics/trading-history":
        setSubMenuActiveTab("Trading History");
        break;
      case "/account-metrics/account-info":
        setSubMenuActiveTab("Account Info");
        break;

      case "/affiliate/overview":
        setSubMenuActiveTab("Overview");
        break;
      case "/affiliate/get-a-link":
        setSubMenuActiveTab("Get a link");
        break;

      case "/request-payout/payout-split":
        setSubMenuActiveTab("Trading account");
        break;
      case "/request-payout/affiliate-payout":
        setSubMenuActiveTab("Affiliate Payout");
        break;
      case "/payout-leaderboard/single-payout":
        setSubMenuActiveTab("Single Payout");
        break;
      case "/payout-leaderboard/combined-payout":
        setSubMenuActiveTab("Combined Payout");
        break;

      // Trading Cup
      // case "/tradingCup-leaderboard":
      //   setActiveTab("Trading Cup");
      //   break;

      case "/trademate/trade-journal":
        setSubMenuActiveTab("Trade Journal");
        break;
      case "/trademate/economic-calendar":
        setSubMenuActiveTab("Economic Calendar");
        break;
      case "/trademate/market-news":
        setSubMenuActiveTab("Market News");
        break;

      case "/Contract-list":
        setActiveTab("Contract");
        break;

      default:
        const plansIndex = parseInt(location.split("/").pop()); // Extract the last part of the path
        if (!isNaN(plansIndex) && plans && plans.data && plans.data[plansIndex]) {
          setSubMenuActiveTab(plans.data[plansIndex].name);
        }
    }
  }, [window.location.pathname, plans]);

  const handleLogout = () => {
    dispatch(deAuthenticate());
    clearPersistedData();
    dispatch(PURGE_Brand());
  };

  const handleEmail = () => {
    const emailAddress = "support@equityedge.io";
    const subject = "Subject of the email";
    const body = "Body of the email";
    const mailtoLink = `mailto:${emailAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink;
  };

  const handleTabClick = (tab, tab2) => {
    setMobileMenu(false);
    setActiveTab(tab);
    setSubMenuActiveTab(tab2);
    if (tab === "Support") {
      handleEmail();
    }
  };
  // const handleMenuAabClick = (tab) => {
  //   setMobileMenu(false);
  //   setSubMenuActiveTab(tab);
  // };
  const {selectedBrand} = useSelector((state) => state.brand);
  const itemss = [
    {
      key: "equity_edge",
      label: (
        <div style={{display: "flex", alignItems: "center", gap: "8px"}}>
          <BrandIcon className="brandTextIcon" />
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="30px"
            height="30px"
          >
            <g
              id="SVGRepo_bgCarrier"
              stroke-width="0"
            ></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289C6.68342 7.90237 7.31658 7.90237 7.70711 8.29289L12 12.5858L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L12.7071 14.7071Z"
                fill="#fff"
              ></path>{" "}
            </g>
          </svg>
        </div>
      ),
      buttonLabel: "Equity Edge",
      number: "#1",
    },
    {
      key: "crypto_edge",
      label: (
        <div style={{display: "flex", alignItems: "center", gap: "8px"}}>
          <CryptoBrandIcon className="brandTextIcon" />
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="30px"
            height="30px"
          >
            <g
              id="SVGRepo_bgCarrier"
              stroke-width="0"
            ></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289C6.68342 7.90237 7.31658 7.90237 7.70711 8.29289L12 12.5858L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L12.7071 14.7071Z"
                fill="#fff"
              ></path>{" "}
            </g>
          </svg>
        </div>
      ),
      buttonLabel: "Crypto Edge",
      number: "#2",
    },
  ];
  const [buttonText, setButtonText] = useState(itemss.find((item) => item.key === selectedBrand?.brand)?.label || "Select Team");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    const updatedLabel = itemss.find((item) => item.key === selectedBrand?.brand)?.label || "Select Team";
    setButtonText(updatedLabel);
  }, [selectedBrand?.brand]);

  const handleMenuClick = (e) => {
    const selectedItem = itemss.find((item) => item.key === e.key);
    setButtonText(selectedItem.label); // Use the buttonLabel property
    dispatch(TOGGLE_Brand(selectedItem?.key)); // Single dispatch call

    if (selectedItem?.key !== selectedBrand?.brand) {
      setTimeout(() => {
        if (window.location.pathname.includes("funding-evaluation") && window.location.pathname.includes("payments")) {
          navigate("/");
        } else {
          // Consider avoiding reload; update state
          window.location.reload();
        }
      }, 500);
    }
  };

  const menuProps = {
    items: itemss.map((item) => ({
      ...item,
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {item.buttonLabel}
        </div>
      ),
    })),
    onClick: handleMenuClick,
  };
  return (
    <>
      <div className={`MainSidebar`}>
        <div className="main-menu">
          <div className="menu">
            {/* <div className="logoBox">
              <Dropdown
                menu={menuProps}
                placement="bottom"
              >
                <Button>{buttonText}</Button>
              </Dropdown>
            </div> */}
            {SidebarData.map((item, index) => {
              let data;
              if (item.title === "Settings") {
                return null;
              }
              if (item.title === "Account Metrics" && accountCount <= 0) {
                data = null;
              } else {
                data = (
                  <SubMenu
                    key={index}
                    item={item}
                    onClick={handleEmail}
                    handleTabClick={handleTabClick}
                    activeTab={activeTab}
                    subMenuActiveTab={subMenuActiveTab}
                    // handleMenuAabClick={handleMenuAabClick}
                  />
                );
              }
              return data;
            })}
          </div>{" "}
          <div
            className="logoutBox cursorPointer"
            onClick={handleLogout}
          >
            <button className="logoutSidebar">
              <LogoutBtn />
              <p>Logout</p>
            </button>
          </div>
        </div>
      </div>

      {/* {mobileMenu ? (
        <MobileSidebar
          setMobileMenu={setMobileMenu}
          activeTab={activeTab}
          handleLogout={handleLogout}
          handleTabClick={handleTabClick}
        />
      ) : (
        ""
      )} */}
    </>
  );
};

export default MainSidebar;

// const MobileSidebar = ({setMobileMenu, mobileMenu, activeTab, handleTabClick, handleLogout}) => {
//   return (
//     <div className={`MobileSidebar`}>
//       <button
//         className="close_btn"
//         onClick={() => setMobileMenu(false)}
//       >
//         close
//       </button>
//       <div className="mobile_menu">
//         <Link
//           to="/"
//           id="Dashboard"
//           className={activeTab === "Dashboard" ? "active" : ""}
//           onClick={() => handleTabClick("Dashboard")}
//         >
//           <img
//             src={dashboardsvg}
//             alt="dashboardsvg"
//           />
//           Dashboard
//         </Link>
//         <Link
//           to="/account-metrics"
//           id="AccountMetrics"
//           className={activeTab === "AccountMetrics" ? "active" : ""}
//           onClick={() => handleTabClick("AccountMetrics")}
//         >
//           <img
//             src={accountmetrixsvg}
//             alt="accountmetrixsvg"
//           />
//           Account Metrics
//         </Link>
//         <Link
//           to="/funding-evaluation/payment-history/all"
//           id="Payment"
//           className={activeTab === "Payment" ? "active" : ""}
//           onClick={() => handleTabClick("Payment")}
//         >
//           <img
//             src={paymentsvg}
//             alt="paymentsvg"
//           />
//           Payment
//         </Link>
//         <Link
//           to="/funding-evaluation/plans"
//           id="FundingEvaluation"
//           className={activeTab === "FundingEvaluation" ? "active" : ""}
//           onClick={() => handleTabClick("FundingEvaluation")}
//         >
//           <img
//             src={fundingsvg}
//             alt="fundingsvg"
//           />
//           Funding Evaluation
//         </Link>

//         {/* <Link
//         to='/buy-funded'
//         id="BuyFundedAccount"
//         className={activeTab === 'BuyFundedAccount' ? "active" : ""}
//         onClick={()=>handleTabClick("BuyFundedAccount")}
//         >
//         <img src={buyFundedIcon} alt="" />
//         Buy  Funded Account
//         </Link> */}

//         <Link
//           to="/trademate/*"
//           id="MarketNews"
//           className={activeTab === "MarketNews" ? "active" : ""}
//           onClick={() => handleTabClick("MarketNews")}
//         >
//           <img
//             src={marketnewssvg}
//             alt="marketnews"
//           />
//           Trade Journal
//         </Link>
//         <Link
//           to="/leaderboard-2"
//           id="Leaderboard"
//           className={activeTab === "Leaderboard" ? "active" : ""}
//           onClick={() => handleTabClick("Leaderboard")}
//         >
//           <img
//             src={leaderboard}
//             alt="leaderboardsvg"
//           />
//           Leaderboard
//         </Link>

//         <Link
//           to="/myprofile/general-information"
//           id="Setting"
//           className={activeTab === "Setting" ? "active" : ""}
//           onClick={() => handleTabClick("Setting")}
//         >
//           <img
//             src={settingsvg}
//             alt="settingsvg"
//           />
//           Setting
//         </Link>

//         <Link
//           to="/support-center"
//           id="Support"
//           className={activeTab === "Support" ? "active" : ""}
//           onClick={() => handleTabClick("Support")}
//         >
//           <img
//             src={supportsvg}
//             alt="supportsvg"
//           />
//           Support
//         </Link>

//         <a
//           onClick={handleLogout}
//           href="/signin"
//           id="Logout"
//           className={activeTab === "Logout" ? "active" : ""}
//         >
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="24"
//             height="24"
//             viewBox="0 0 24 24"
//             fill="none"
//           >
//             <path
//               d="M7.2 13.2H16.8C17.14 13.2 17.425 13.085 17.655 12.855C17.885 12.625 18 12.34 18 12C18 11.66 17.885 11.375 17.655 11.145C17.425 10.915 17.14 10.8 16.8 10.8H7.2C6.86 10.8 6.575 10.915 6.345 11.145C6.115 11.375 6 11.66 6 12C6 12.34 6.115 12.625 6.345 12.855C6.575 13.085 6.86 13.2 7.2 13.2ZM12 24C10.34 24 8.78 23.685 7.32 23.055C5.86 22.425 4.59 21.57 3.51 20.49C2.43 19.41 1.575 18.14 0.945 16.68C0.315 15.22 0 13.66 0 12C0 10.34 0.315 8.78 0.945 7.32C1.575 5.86 2.43 4.59 3.51 3.51C4.59 2.43 5.86 1.575 7.32 0.945C8.78 0.315 10.34 0 12 0C13.66 0 15.22 0.315 16.68 0.945C18.14 1.575 19.41 2.43 20.49 3.51C21.57 4.59 22.425 5.86 23.055 7.32C23.685 8.78 24 10.34 24 12C24 13.66 23.685 15.22 23.055 16.68C22.425 18.14 21.57 19.41 20.49 20.49C19.41 21.57 18.14 22.425 16.68 23.055C15.22 23.685 13.66 24 12 24ZM12 21.6C14.68 21.6 16.95 20.67 18.81 18.81C20.67 16.95 21.6 14.68 21.6 12C21.6 9.32 20.67 7.05 18.81 5.19C16.95 3.33 14.68 2.4 12 2.4C9.32 2.4 7.05 3.33 5.19 5.19C3.33 7.05 2.4 9.32 2.4 12C2.4 14.68 3.33 16.95 5.19 18.81C7.05 20.67 9.32 21.6 12 21.6Z"
//               fill="white"
//             />
//           </svg>
//           Quit
//         </a>
//       </div>
//     </div>
//   );
// };
